<template>
  <div class="dialog-wrap">
    <el-dialog
      title="提现详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="1180px"
    >
      <div class="header-wrap">
        <div class="header-item">
          <p>本次申请提现：{{withdrawInfo.amount || 0}}元</p>
        </div>
        <div class="header-item">
          <p>收款方式：{{handleRender(withdrawInfo.fee_account_type, 'payType')}}</p>
          <p>收款人姓名：{{withdrawInfo.fee_account_name}}</p>
          <p>收款人账号：{{withdrawInfo.fee_account_card}}</p>
        </div>
        <div class="header-item">
          <p>提现状态：
            <el-tag v-if="withdrawInfo.status === 0">提现中</el-tag>
            <el-tag
              type="success"
              v-if="withdrawInfo.status === 1"
            >提现成功</el-tag>
            <el-tag
              type="danger"
              v-if="withdrawInfo.status === 2"
            >提现已撤销</el-tag>
            <el-tag
              type="danger"
              v-if="withdrawInfo.status === 3"
            >提现被驳回</el-tag>
          </p>
          <div v-if="withdrawInfo.status === 0">
            <el-button
              size="mini"
              type="primary"
              @click="openDialogFormVisible"
            >审核通过，确认去打款</el-button>
            <el-button
              size="mini"
              plain
              @click="handleWithdrawCancel"
            >审核不通过，驳回提现</el-button>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="table-wrap">
        <div class="title">
          <h3>提现订单核对</h3>
          <!-- <el-button class="export-button" type="text">下载excel</el-button> -->
        </div>
        <el-table
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="ref_id"
            label="订单ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="商品类型"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ handleRender(scope.row.goods_type, 'productType') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="商品名称"
            align="center"
          >
            <template slot-scope="scope">
              <div style="text-align:left;">{{ scope.row.goods_name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_nickname"
            label="购买用户"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="订单金额(元)"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.amount }}元</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单状态"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ statusRender(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="支付时间"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{  $moment(scope.row.create_time).format('YYYY-MM-DD hh:mm')  }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单收益"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{scope.row.amount}}元</span>
            </template>
          </el-table-column>
          <el-table-column
            label="收益类型"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <!--    {{scope.row.parent_level==0?'推广佣金':'邀请奖励'}} -->
              <span>{{ handleRender(scope.row.parent_level, 'parentLevel') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="结算状态"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                type="danger"
                size="mini"
                v-if="scope.row.status==0"
              >待结算</el-tag>
              <el-tag
                size="mini"
                v-if="scope.row.status==1"
              >已结算</el-tag>
              <el-tag
                type="info"
                size="mini"
                v-if="scope.row.status==2"
              >已撤销</el-tag>
              <el-tag
                type="success"
                size="mini"
                v-if="scope.row.status==3"
              >已提现</el-tag>
              <el-tag
                type="warning"
                size="mini"
                v-if="scope.row.status==4"
              >提现中</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      title="请输入验证码"
      :visible.sync="dialogFormVisible"
      width="420px"
    >
      <el-form
        :model="form"
        style="display:flex;"
      >
        <el-form-item :label="phone">
          <el-input
            v-model="form.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item style="align-self:flex-end;margin-left:16px;">
          <el-button
            type="primary"
            size="small"
            :disabled="codedisabled"
            @click="sendsms"
          >{{
          yzcodetext
        }}</el-button>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="handleAccept"
        >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="拒绝理由"
      :visible="refuseVisible"
      width="500px"
    >
      <el-form
        :model="refuseForm"
        ref="dialogForm"
        :rules="rules"
      >
        <el-form-item prop="remark">
          <el-input
            type="textarea"
            v-model="refuseForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="refuseVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submit('dialogForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { memberProfitLogs, memberWithdrawOne, memberWithdrawRevoke } from '@/api/member'
import { getStorage } from '@/utils/helper'
import { withdrawaccess, smscodemobile, withdrawsendsmscode } from "@/api/distribution"

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      query: {
        ids: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      withdrawInfo: {},
      profitInfo: {},
      results: [],
      dialogFormVisible: false,
      form: {},
      refuseForm: {},
      rules: {
        remark: [
          { required: true, message: "请输入拒绝理由", trigger: "blur" },
        ],
      },
      refuseVisible: false,
      phone: "",
      codedisabled: false,
      yzcodetext: "获取验证码",
      codeTime: 0,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val

      if (val) {
        this.fetchWithdrawInfo()
      }
    }
  },
  methods: {
    // 提现信息查询
    fetchWithdrawInfo() {
      memberWithdrawOne({ id: this.content.id }).then(res => {
        this.withdrawInfo = res
        if (res.ref_ids) {
          this.query.ids = res.ref_ids
          this.fetchProfitLogs()
        }
      })
    },
    // 驳回提现
    handleWithdrawCancel() {
      // 二次确认撤销
      this.$confirm("确定要驳回吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.refuseVisible = true
      }).catch(() => { });
    },
    // 学长营收记录请求
    fetchProfitLogs() {
      memberProfitLogs(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchProfitLogs()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchProfitLogs()
    },
    handleClose() {
      this.$emit('close')
    },
    handleRender(value, type) {
      let productTypes = {
        '1': '课程',
        '2': '题库',
        '3': '专栏',
        '4': '资料',
        '5': '文章',
        '6': '学长',
        '7': '联报',
        '8': '课酬',
      }
      let status = {
        '0': '待结算',
        '1': '已结算',
        '2': '已退款',
        '3': '已提现',
        '4': '提现中',
      }
      let payTypes = {
        '1': '支付宝',
        '2': '微信'
      }
      let parentLevel = {
        '0': '推广佣金',
        '1': '邀请奖励',
        '200': '创作收益',
        '201': '课时课酬',
        '203': '学长推荐',
      }
      if (type == 'productType') {
        return productTypes[value] || ''
      } else if (type == 'status') {
        return status[value] || ''
      } else if (type == 'payType') {
        return payTypes[value] || ''
      } else if (type == 'parentLevel') {
        return parentLevel[value] || ''
      }
      return ''
    },
    openDialogFormVisible() {
      smscodemobile().then((res) => {
        this.phone = `输入${res}收到的手机验证码`
        this.dialogFormVisible = true
      })

    },
    handleAccept() {
      let query = {
        password: this.form.password,
        withdraw_id: this.content.id
      }
      withdrawaccess(query).then((res) => {
        this.$message.success(`操作成功`);
        this.dialogFormVisible = false
        this.$emit('submit')
        this.handleClose()
      })
    },
    // 订单状态渲染
    statusRender(row) {
      const order_status = {
        0: "待支付",
        1: "已支付",
        2: "待发货",
        3: "待收货",
        4: "已完成",
        5: "已取消",
      };
      return order_status[row.order_status] || "";
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let query = {
            remark: this.refuseForm.remark,
            withdraw_id: this.withdrawInfo.id
          };
          memberWithdrawRevoke(query).then((res) => {
            this.$message.success(`驳回成功`);
            this.refuseVisible = false
            this.$emit('submit')
            this.handleClose()
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    timer() {
      if (this.codeTime > 0) {
        this.codeTime--;
        this.yzcodetext = this.codeTime + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.codeTime = 0;
        this.yzcodetext = "获取验证码";
        this.codedisabled = false;
      }
    },
    sendsms() {
      this.codeTime = 60;
      this.codedisabled = true;
      withdrawsendsmscode().then((res) => {
        this.timer();
      });
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .header-item {
    display: flex;
    align-items: center;

    & + .header-item {
      margin-top: 10px;
    }
    & > p {
      font-weight: bold;
      margin-right: 20px;
    }
  }
  .table-wrap {
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    .export-button {
      padding: 0;
      margin-left: 10px;
    }
  }
  .footer-wrap {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
}
</style>
